import { Phone, Menu, X } from "lucide-react";
import { useState, useEffect } from "react";

const navItems = [
  { label: "What is Surplus?", href: "#education" },
  { label: "Process", href: "#process" },
  { label: "Why Us", href: "#why-us" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
  { label: "Claim Check", href: "#claim" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-[#FDFBF7]/95 backdrop-blur border-b border-[#E2DCD0]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <a
            href="#top"
            data-testid="brand-logo"
            className="flex items-center gap-3 group"
          >
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-sm bg-[#0A192F] text-[#D4AF37] font-serif-display text-2xl leading-none">
              ★
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-serif-display text-[#0A192F] text-lg font-semibold">
                Lone Star
              </span>
              <span className="font-sans-body text-[10px] uppercase tracking-[0.22em] text-[#1E3A5F]">
                Surplus Recovery LLC
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-9">
            {navItems.map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`nav-${n.href.replace("#", "")}`}
                className="text-sm text-[#1E3A5F] hover:text-[#0A192F] transition-colors relative font-medium tracking-wide"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:8176802751"
              data-testid="header-phone-link"
              className="flex items-center gap-2 text-sm font-semibold text-[#0A192F] hover:text-[#D4AF37] transition-colors"
            >
              <Phone className="h-4 w-4" />
              817-680-2751
            </a>
            <a
              href="#claim"
              data-testid="header-cta"
              className="bg-[#0A192F] text-[#FDFBF7] hover:bg-[#112B4F] transition-colors text-sm font-medium px-6 py-3 rounded-sm tracking-wide"
            >
              Free Claim Check
            </a>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-[#0A192F]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {open && (
          <div
            data-testid="mobile-menu"
            className="lg:hidden pb-6 border-t border-[#E2DCD0] pt-4 space-y-1"
          >
            {navItems.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="block px-2 py-3 text-[#0A192F] hover:bg-[#F3F0E6] rounded-sm"
              >
                {n.label}
              </a>
            ))}
            <a
              href="tel:8176802751"
              className="flex items-center gap-2 px-2 py-3 text-[#0A192F] font-semibold"
            >
              <Phone className="h-4 w-4" /> 817-680-2751
            </a>
            <a
              href="#claim"
              onClick={() => setOpen(false)}
              className="block bg-[#0A192F] text-[#FDFBF7] px-4 py-3 text-center rounded-sm mt-2"
            >
              Free Claim Check
            </a>
          </div>
        )}
      </div>
    </header>
  );
};
